module.exports = __webpack_public_path__ + "static/23-07a06864ca152d43ccb328e6f8e004f4.jpg";